// extracted by mini-css-extract-plugin
export default {"description":"ReferralModal-module__description--tmOwI","field":"ReferralModal-module__field--o6wm6"};